import WalasSingle from "../../../../../components/categories/siakad/lms/data_walas_single/Home";
export default function Home() {
  
  return (
    <WalasSingle />
  );
}
